/** Currency + misc formatting helpers. */

export function formatKES(amount: number): string {
  return `KES ${amount.toLocaleString('en-KE')}`;
}

/** Normalize a Kenyan phone number to the 2547XXXXXXXX international form. Returns null if invalid. */
export function normalizeKenyanPhone(input: string): string | null {
  const digits = input.replace(/[^\d]/g, '');
  let national: string | null = null;

  if (/^(?:254)(7\d{8}|1\d{8})$/.test(digits)) {
    national = digits;
  } else if (/^0(7\d{8}|1\d{8})$/.test(digits)) {
    national = `254${digits.slice(1)}`;
  }

  return national;
}

export function isValidKenyanPhone(input: string): boolean {
  return normalizeKenyanPhone(input) !== null;
}

/** Display a 2547XXXXXXXX number as 0712 345 678. */
export function formatKenyanPhone(normalized: string): string {
  const local = `0${normalized.slice(3)}`;
  return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
}
